import {PIXIUIModule} from "@dp-instant/2d";
import {di, LazyAction} from "@dp-instant/core";
import {TypesFlow, TypesNotification, TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import {HTMLUIModule} from "@dp-instant/ui";
import {NAStartSIO} from "@game/actions/NAStartSIO";
import {ShareActionOk} from "@game/actions/ShareActionOk";
import {SIOPreloadAssetsAction} from "@game/actions/SIOPreloadAssetsAction";
import {GameUIModule} from "@game/ui/GameUIModule";
import {ContainerModule, interfaces} from "inversify";
import {MainAction} from "./actions/MainAction";
import {CoreGameModule} from "./coregame/CoreGameModule";

export const GameModule = new ContainerModule((bind: interfaces.Bind, unbind, isBound, rebind) => {
    di.load(PIXIUIModule);
    di.load(HTMLUIModule);
    di.load(CoreGameModule);
    di.load(GameUIModule);
    isBound(TypesNotification.start) && rebind(TypesNotification.start).to(NAStartSIO);

    bind(TypesFlow.assetsPreload).to(SIOPreloadAssetsAction);
    bind(TypesFlow.mainAction).to(MainAction);

    if (__SOCIAL__ === "fb") {
        bind(TypesFlow.share).toConstantValue(
            new LazyAction(async (image: string) => {
                const social = di.get<ISocial>(TypesSocial.model);
                return await social.share({
                    intent: "SHARE",
                    text: `No one can beat ${social.me.name} in State.io!`,
                    image
                });
            })
        );
    } else if (__SOCIAL__ === "ok") {
        bind(TypesFlow.share).to(ShareActionOk);
    }
});
